import React from "react";
import styled from "styled-components";
import assertUnreachable from "logic/assertUnreachable";
import { range } from "views/components/searchbar/time-range-filter/TimeRangeDisplay";
const StyledDL = styled.dl`
  && {
    > span {
      display: flex;
      gap: 5px;
    }

    dt {
      white-space: nowrap;
      flex-basis: 175px;
    }

    dd {
      margin: 0;
      flex: 1;
    }
  }
`;
export const getTimeRangeValueSummary = (timerange) => {
  switch (timerange.type) {
    case "relative":
      return `${range(timerange).from} - ${range(timerange).until}`;
    case "absolute":
      return `${range(timerange).from} - ${range(timerange).until}`;
    case "keyword":
      return timerange.keyword;
    default:
      return assertUnreachable(timerange, "Timerange type doesn't not exist");
  }
};
const TimeRangePresetOptionSummary = ({ options }) => /* @__PURE__ */ React.createElement(StyledDL, { className: "deflist" }, options.map(({ timerange, id, description }) => /* @__PURE__ */ React.createElement("span", { key: `timerange-options-summary-${id}` }, /* @__PURE__ */ React.createElement("dt", null, getTimeRangeValueSummary(timerange)), /* @__PURE__ */ React.createElement("dd", null, description))));
export default TimeRangePresetOptionSummary;
